import { DiagnosisRegistrationStoreData } from '@/pages/demands/contexts/diagnosis-registration-store'

export interface ImageCountMapperProps {
  selectFilesData: DiagnosisRegistrationStoreData['selectFilesData']
}

export class ImageCountMapper {
  private selectFilesData

  constructor(props: ImageCountMapperProps) {
    this.selectFilesData = props.selectFilesData
  }

  getImageCount(): number {
    const rgbImages = this.selectFilesData?.rgb?.results?.image_count ?? 0
    const thermalImages =
      this.selectFilesData?.thermal?.results?.image_count ?? 0

    return rgbImages + thermalImages
  }
}
